import { COUNTRIES } from 'src/constants/countries'
import { getKeyByMarket } from 'lib/utils/country'

interface AvailableCredit {
  currency: string
  value: number
}

export function getCurrencyFromUserMarket(availableCredit: AvailableCredit[], marketParam: string) {
  const marketFound = getKeyByMarket(marketParam)

  if (!marketFound) {
    return undefined
  }

  const currency = availableCredit?.find(
    currencyObject => currencyObject?.currency === COUNTRIES[marketFound]?.currency
  )

  return currency
}
